import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { observer } from 'mobx-react-lite'
import { opt } from 'store/opt'
import { store } from 'store/store'
import { getUnitLabel, getUnitValue } from 'type/LengthUnit'
import { disk } from 'util/typo'

type Props = {
  label: string
  value: number
  plus?: boolean
}

export const SizeLabel = observer(({ label, value, plus }: Props) => {
  const { unit } = store.profile

  const size = opt.stand ? 16 : 14

  return <Space gap={4} height={24}>
    <Typo size={size - 2} upper>
      {label}
    </Typo>
    <Typo size={size - 2}>
      {disk}
    </Typo>
    <Typo size={size} medium>
      {getUnitValue(value, unit)}{plus && '+'}
    </Typo>
    <Typo size={size - 2} upper>
      {getUnitLabel(value, unit)}
    </Typo>
  </Space>
})
